import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { paths } from '@/app/routes/paths';
import { canManageSites, isOrganisationAdmin, useAuthStore } from '@/store';

/**
 * Organisation settings: Org Admin, or a Coordinator with delegated site management
 * (client 6.1 / 7.7), who only gets the Service sites tab.
 */
export function RequireOrganisationSettingsAccess({ children }: { children: ReactNode }) {
  const user = useAuthStore((s) => s.user);

  if (!user) {
    return null;
  }

  if (!isOrganisationAdmin(user) && !canManageSites(user)) {
    return <Navigate to={paths.dashboard} replace />;
  }

  return children;
}
